// @ts-check

/**
 * @module network/fetchJson
 */

import { post, get } from './fetch';

/**
 * This method is preserved here for backwards compatibility but has been moved
 * to ./fetch.js as `post`
 *
 * Fires a networked POST request with data serialized to json to an api
 * endpoint with the required options for api calls in itslearning
 * @param {object} data - data object to post with the request (will be JSON stringified)
 * @param {string} url - the url of the endpoint to post the data to
 * @param {object} [options] - Optional options for overriding the fetch defaults
 * @param {string} [options.cache=default] - cache mode of the request: default, reload, no-cache
 * @param {string} [options.mode=cors] - mode of the request: cors, no-cors, same-origin, navigate
 * @param {string} [options.credentials=same-origin] - credentials of the request: omit, same-origin, include
 * @param {object} [options.headers] - additional headers for the request
 * @returns {Promise} the json response returned by the api or the text if the response is not json
 */
export const postJson = post;

/**
 *  * This method is preserved here for backwards compatibility but has been moved
 * to ./fetch.js as `get`
 *
 * Fires a networked GET request to an endpoint with the required options for
 * api calls in itslearning
 * @param {string} url - the url of the endpoint to GET
 * @param {object} [options] - Optional options for overriding the fetch defaults
 * @param {string} [options.cache=default] - cache mode of the request: default, reload, no-cache
 * @param {string} [options.mode=cors] - mode of the request: cors, no-cors, same-origin, navigate
 * @param {string} [options.credentials=same-origin] - credentials of the request: omit, same-origin, include
 * @param {object} [options.headers] - additional headers for the request
 * @returns {Promise} the json response returned by the api
 */
export const getJson = get;
